import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import ApiApplication from '@/api/identityProvider/application'
import ApiObject from '@/api/identityProvider/object'
import ApiObjectType from '@/api/identityProvider/object-type'

import ObjectModel from '@/model/identity-provider/object'
import ObjectTypeConstants from '@/constants/controle-acesso/object-type'

export default {  
    mixins: [ FormMixin, DateMixin ], 
    data(){
        return {
            rules:{
                aplicacao: [
                    val => {
                        if((val || null) == null)
                            return this.cboAplicacaoOrigatoria;

                        return true;
                    }
                ],                
                uniqueCode: [
                    val => {
                        if((val || null) == null)
                            return this.ruleCodigoUnico;

                        return true;
                    }
                ],                               
                description: [
                    val => {
                        if((val || null) == null)
                            return this.ruleDescricao;

                        return true;
                    }
                ]
            },
            lista:{
                menu: [],
                objeto: [],
                aplicacao: []
            },
            menu: new ObjectModel().returnModel(),
            menuObjectType: null,
            parentObject: null
        }
    }, 
    computed: {  
        title () {
            return this.$t('Views.ControleAcesso.Menu.Listar.form-title')
        },
        inputCodigoUnico(){
            return this.$t('Views.ControleAcesso.Menu.Editar.codigo-unico')
        },
        ruleCodigoUnico(){
            return this.$t('Views.ControleAcesso.Menu.Editar.rule-codigo-unico')            
        },        
        inputDescricao(){
            return this.$t('Views.ControleAcesso.Menu.Editar.descricao')            
        },
        ruleDescricao(){
            return this.$t('Views.ControleAcesso.Menu.Editar.rule-descricao')            
        },
        cboObjetoPai(){
            return this.$t('Views.ControleAcesso.Menu.Editar.objeto-pai')            
        },
        cboObjetoPaiSemDados(){
            return this.$t('Views.ControleAcesso.Menu.Editar.objeto-pai-sem-dados')            
        },
        cboAplicacao(){
            return this.$t('Views.ControleAcesso.Menu.Editar.aplicacao')            
        },
        cboAplicacaoSemDados(){
            return this.$t('Views.ControleAcesso.Menu.Editar.aplicacao-sem-dados')            
        },                     
        cboAplicacaoOrigatoria(){
            return this.$t('Views.ControleAcesso.Menu.Editar.rule-aplicacao')            
        }        
    },
    methods:{
        createMenuHierarchy(parentNode){
            let parent = this.lista.menu.filter(
                (m) => (parentNode != null && m.parentObject != null && m.parentObject.id == parentNode.id) || 
                       (parentNode == null && m.parentObject == null)
            );

            let listOfHierarchyMenu = [];
            for(let i = 0; i < parent.length; i++){
                let object = parent[i];
                object.isOpen = (parentNode != null);

                object.child = this.createMenuHierarchy(object);
                listOfHierarchyMenu.push(object);
            }

            return listOfHierarchyMenu;
        },
        async listarTipoObjeto(){
            const resultado = await ApiObjectType.listarPorCodigoUnico(ObjectTypeConstants.menu).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this, "menuObjectType", resultado.data);
            }
        },
        async listarAplicacao(){
            const resultado = await ApiApplication.listar().catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this.lista, "aplicacao", resultado.data);
            }
        },
        async listarObjeto(){
            const resultado = await ApiObject.listarPorTipoObjeto(this.menuObjectType.id).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this.lista, "objeto", resultado.data);
            }
        }       
    }
}